<template>
    <div class="print-preview">
        <div class="text-center">
            <h2>{{user.doctor.clinic_name}}</h2>
            <p>{{user.doctor.field}}</p>
            <p>{{user.doctor.clinic_address}}</p>
            <p>Clinic Hours: {{user.doctor.business_hours}}</p>
            <p>Telephone No.: {{user.doctor.clinic_tel_number}} Email: {{user.email}}</p>
        </div>
        <div v-if="!Object.keys(user).length">
            <div class="text-center mt-5 text-danger">No medical data to preview.</div>
        </div>
        <div class="content mt-5" v-else>
            <p>I, the undersigned Dr. <span>{{user.name}}</span>, Doctor of {{user.doctor.field}},
                Certify that the examination of Mr/Ms. <span>{{appointment.patient_name}}</span> Lorem ipsum dolor sit
                amet,
                consectetur adipisicing elit.</p>

            <p>Medical certificate issued in <span>{{user.doctor.clinic_address}}</span></p>
            <p class="mt-5"><strong>Diagnosis</strong>:<br>
                <span class="pre-wrap">{{appointment.diagnosis}}</span>
            </p>
            <div><strong>Recommendation</strong>:<br>
                <div class="pre-wrap">{{appointment.recommendation}}</div>
            </div>
            <div class="d-flex med-footer mt-5">
                <div>
                    <p>
                        <strong>Doctor Sign</strong>:
                        <span>{{user.name}} {{user.salutation}}</span>
                    </p>
                    <p>
                        <strong>License Number</strong>:
                        <span>{{user.doctor.license_number}}</span>
                    </p>
                    <p>
                        <strong>Ptr No.</strong>:
                        <span>{{user.doctor.ptr_number}}</span>
                    </p>
                </div>
                <div><strong>Date</strong>: <span>{{appointment.appointment_date.toLocaleDateString()}}</span></div>
            </div>

            <p class="text-right margin-top-150">
                <button @click="print" class="btn btn-orange">Print</button>
            </p>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        appointment: {},
        user: {},
        setting: {}
      }
    },

    methods: {
      initialize() {
        console.log(this.$route.params, 'this.$route.params');
        this.appointment = this.$route.params['appointment'] || {};
        this.user = this.$route.params['user'] || {};
        this.setting = this.$route.params['setting'] || {};
      },

      print() {
        window.print();
      }
    },
    created() {
      this.initialize();
    }
  }
</script>

<style scoped>
    .print-preview {
        background: #FFFFFF;
        height: 100vh;
        margin: 0 10px;
        padding: 100px;
    }

    .content {
        max-width: 900px;
        margin: auto;
    }

    .content span {
        text-decoration: underline;
    }

    .med-footer {
        justify-content: space-between;
    }

    @media print {
        .btn-success {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Certificate/Preview.vue